import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';

import DesignSystemWrapper from '@components/DesignSystemWrapper';
import { CssBaseline } from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';
import { LicenseInfo } from '@mui/x-license-pro';
import i18n from '@plugins/i18n';
import { store } from '@stores/store';
import constants from 'constants/constants';

import { App } from './App';

/* MUI x-pro */
LicenseInfo.setLicenseKey(constants.System.MUI_LICENSE_KEY);

const rootContainer = document.getElementById('root');

const root = createRoot(rootContainer!);
root.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <StyledEngineProvider injectFirst>
        <DesignSystemWrapper>
          <CssBaseline />
          <App />
        </DesignSystemWrapper>
      </StyledEngineProvider>
    </I18nextProvider>
  </Provider>,
);
